import { AttributeEditor } from './AttributeEditor';
import { EventType } from './EventType';
import { SubscriptionListEditor } from './SubscriptionListEditor';
import { TagEditor } from './TagEditor';
import { TagGroupEditor } from './TagGroupEditor';
/**
 * Airship channel.
 */
export class AirshipChannel {
    constructor(plugin) {
        this.plugin = plugin;
    }
    /**
     * Gets the device tags.
     * @returns A promise with the result.
     */
    getTags() {
        return this.plugin.perform('channel#getTags');
    }
    /**
     * Gets the channel Id.
     *
     * @returns A promise with the result.
     */
    getChannelId() {
        return this.plugin.perform('channel#getChannelId');
    }
    /**
     * Returns the channel ID. If the channel ID is not yet created the function it will wait for it before returning. After
     * the channel ID is created, this method functions the same as `getChannelId()`.
     *
     * @returns A promise with the result.
     */
    waitForChannelId() {
        return this.plugin.perform('channel#waitForChannelId');
    }
    /**
     * Gets a list of the channel's subscriptions.
     * @returns A promise with the result.
     */
    getSubscriptionLists() {
        return this.plugin.perform('channel#getSubscriptionLists');
    }
    /**
     * Edits tags.
     * @returns A tag group editor.
     */
    editTags() {
        return new TagEditor((operations) => {
            return this.plugin.perform('channel#editTags', operations);
        });
    }
    /**
     * Edits tag groups.
     * @returns A tag group editor.
     */
    editTagGroups() {
        return new TagGroupEditor((operations) => {
            return this.plugin.perform('channel#editTagGroups', operations);
        });
    }
    /**
     * Edits attributes.
     * @returns An attribute editor.
     */
    editAttributes() {
        return new AttributeEditor((operations) => {
            return this.plugin.perform('channel#editAttributes', operations);
        });
    }
    /**
     * Edits subscription lists.
     * @returns A subscription list editor.
     */
    editSubscriptionLists() {
        return new SubscriptionListEditor((operations) => {
            return this.plugin.perform('channel#editSubscriptionLists', operations);
        });
    }
    /**
     * Enables channel creation if channel creation has been delayed.
     * It is only necessary to call this when isChannelCreationDelayEnabled
     * has been set to `true` in the airship config.
     * Deprecated. Use the Private Manager to disable all features instead.
     */
    enableChannelCreation() {
        return this.plugin.perform('channel#enableChannelCreation');
    }
    /**
     * Adds a channel created listener
     */
    onChannelCreated(listener) {
        return this.plugin.addListener(EventType.ChannelCreated, listener);
    }
}
//# sourceMappingURL=AirshipChannel.js.map